import { Router } from '@angular/router';

export function handleError(error: any, router: Router): void {
	if (error.status === 401) {
		// router.navigate(['/login']);
	}
}

export class ErrorHelper {}
